import React from 'react'
import { useFormContext } from 'react-hook-form';

import ColumnLabel from '@/main/components/common/columnLabel/columnLabel';
import { getTranslateByKey } from '@/main/services/utils';

import SecondaryButton from '@/main/components/shared/button/secondaryButton';
import Box from '@/main/components/shared/box';
import KogAutoCompleteControlled from '@/main/components/shared/inputAutoComplete/autoCompleteControlled';
import KogAutoCompleteVehicleControlled from '@/main/components/shared/inputAutoComplete/autoCompleteVehicleControlled';
import { KeyValue } from '@/main/models/common';
import { userIsAdmin } from '@/main/services/utilsUser';

import { IPreQuoteForm, usePreQuoteContext } from '../context';
import * as SPage from '../styles';
import * as S from './styles';
import { Controls } from '@/main/services/constants/constantsControl';
import useKogControlElementId from '@/main/hooks/useKogControlElementId';

interface ISectionVehicleProps {
  setOpenModalImages: React.Dispatch<React.SetStateAction<boolean>>;
}

function SectionVehicle({
  setOpenModalImages
}: ISectionVehicleProps) {
  const CONTROL_VEHICLE_SECTION = useKogControlElementId(Controls.IdVehicleSession);

  const {
    preQuoteData,
    vehicleManufacturers,
    vehicleModels,
    vehicleYears,
    subModels,
    loadVehicleManufacurer,
    loadVehicleModel,
    loadSubModel,
    loadVehicleYears,
    isLoadingVehicleManufacturer,
    isLoadingVehicleModel,
    isLoadingVehicleYear,
    isLoadingSubModel,
  } = usePreQuoteContext();
  const {
    control,
    setValue,
    getValues,
  } = useFormContext<IPreQuoteForm>();
  const isAdmin = userIsAdmin();

  if (!preQuoteData?.vehiclePending || !CONTROL_VEHICLE_SECTION) return null;

  return (
    <>
      <Box
        showBox={true}
        title={getTranslateByKey('information.vehicleInformation')}>
        <S.RowInputsVehicleInformation>
          <KogAutoCompleteControlled
            id="id-preQuote-autocomplete-year"
            nameCustom="year"
            label={getTranslateByKey('information.year')}
            control={control}
            rulesCustom={{ required: true }}
            options={vehicleYears}
            isLoading={isLoadingVehicleYear}
            onChangeCustom={(optionSelected: KeyValue | null) => {
              loadVehicleManufacurer(
                getValues('model'),
                getValues('trim'),
                optionSelected
              );
              loadVehicleModel(
                getValues('manufacturer'),
                getValues('trim'),
                optionSelected
              );
              loadSubModel(
                getValues('manufacturer'),
                getValues('model'),
                optionSelected
              );
            }}
            setValueCustom={setValue}
            disabled={
              isLoadingVehicleYear
            }
          />
          <KogAutoCompleteVehicleControlled
            id="id-preQuote-autocomplete-manufacturer"
            nameCustom="manufacturer"
            label={getTranslateByKey('information.manufacturer')}
            control={control}
            options={vehicleManufacturers}
            isLoading={isLoadingVehicleManufacturer}
            rulesCustom={{ required: true }}
            onChangeCustom={(optionSelected: KeyValue | null) => {
              loadVehicleModel(
                optionSelected,
                getValues('trim'),
                getValues('year')
              );
              loadSubModel(
                optionSelected,
                getValues('model'),
                getValues('year')
              );
              loadVehicleYears(
                optionSelected,
                getValues('model'),
                getValues('trim')
              );
            }}
            setValueCustom={setValue}
            disabled={!isAdmin || isLoadingVehicleManufacturer}
          />
          <KogAutoCompleteVehicleControlled
            id="id-preQuote-autocomplete-model"
            nameCustom="model"
            label={getTranslateByKey('information.model')}
            control={control}
            isLoading={isLoadingVehicleModel}
            options={vehicleModels}
            rulesCustom={{ required: true }}
            onChangeCustom={(optionSelected: KeyValue | null) => {
              loadVehicleManufacurer(
                optionSelected,
                getValues('trim'),
                getValues('year')
              );
              loadSubModel(
                getValues('manufacturer'),
                optionSelected,
                getValues('year')
              );
              loadVehicleYears(
                getValues('manufacturer'),
                optionSelected,
                getValues('trim')
              );
            }}
            setValueCustom={setValue}
            disabled={!isAdmin || isLoadingVehicleModel}
          />
          <KogAutoCompleteVehicleControlled
            id="id-preQuote-autocomplete-trim"
            nameCustom="trim"
            label={getTranslateByKey('information.trim')}
            control={control}
            options={subModels}
            isLoading={isLoadingSubModel}
            rulesCustom={{ required: true }}
            onChangeCustom={(optionSelected: KeyValue | null) => {
              loadVehicleManufacurer(
                getValues('model'),
                optionSelected,
                getValues('year')
              );
              loadVehicleModel(
                getValues('manufacturer'),
                optionSelected,
                getValues('year')
              );
              loadVehicleYears(
                getValues('manufacturer'),
                getValues('model'),
                optionSelected
              );
            }}
            setValueCustom={setValue}
            disabled={isLoadingSubModel}
          />
        </S.RowInputsVehicleInformation>
      </Box>
    </>
  )
}

export default SectionVehicle